import React, { useState, useEffect } from 'react';
import firmService from '../../services/firmService';

const SYSTEM_TEMPLATE_FIRM_ID = '00000000-0000-0000-0000-000000000000';

const ObservabilityFirmPicker = ({ selectedFirmId, onFirmChange }) => {
  const [firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFirms = async () => {
      try {
        const allFirms = await firmService.getAllFirms();
        const filtered = allFirms.filter((f) => f.id !== SYSTEM_TEMPLATE_FIRM_ID);
        setFirms(filtered);
      } catch (err) {
        console.error('Error loading firms for observability picker:', err);
      } finally {
        setLoading(false);
      }
    };
    loadFirms();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    onFirmChange(value || null);
  };

  return (
    <div className="flex items-center space-x-3">
      <label htmlFor="obs-firm-picker" className="text-sm font-medium text-gray-700 whitespace-nowrap">
        Viewing:
      </label>
      <select
        id="obs-firm-picker"
        value={selectedFirmId || ''}
        onChange={handleChange}
        disabled={loading}
        className="border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 outline-none"
      >
        <option value="">All Firms (System Overview)</option>
        {firms.map((firm) => (
          <option key={firm.id} value={firm.id}>
            {firm.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ObservabilityFirmPicker;
